import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy, faShareAlt } from "@fortawesome/free-solid-svg-icons";

const ShareButton = ({
  riskSeeking,
  lossAversion,
  magnitude,
  earnings,
  earned_money,
  role,
  use_navigator_share,
}) => {
  const [copied, setCopied] = useState(false);

  const getEmojiString = (position) => {
    return Array.from({ length: 5 }, (_, index) =>
      index + 1 === position ? "🟩" : "⬜"
    ).join("");
  };

  const generateResultsText = () => {
    let text = role;
    text = text + "\n" + getEmojiString(riskSeeking[2]) + " " + riskSeeking[3];
    text =
      text + "\n" + getEmojiString(lossAversion[2]) + " " + lossAversion[3];
    text = text + "\n" + getEmojiString(magnitude[2]) + " " + magnitude[3];
    if (earned_money) {
      text = text + "\n" + "I earned " + earnings;
    } else {
      text = text + "\n" + "I lost " + earnings;
    }
    text = text + "\nhttps://bias.bet";
    return text;
  };

  const handleShare = async () => {
    const resultsText = generateResultsText();

    if (use_navigator_share) {
      if (navigator.share) {
        try {
          await navigator.share({
            title: "bias.bet",
            text: resultsText,
            url: window.location.href,
          });
          console.log("Content shared successfully");
        } catch (error) {
          console.log("Error sharing content:", error);
        }
      } else {
        alert("Share functionality not supported in your browser");
      }
    } else {
      navigator.clipboard
        .writeText(resultsText)
        .then(() => {
          setCopied(true);
          setTimeout(() => setCopied(false), 800); // Reset message after .8s
        })
        .catch((err) => console.error("Failed to copy: ", err));
    }
  };

  return (
    <>
      <button
        onClick={handleShare}
        className={`${use_navigator_share ? "share-button" : "copy-button"}`}
      >
        <FontAwesomeIcon icon={use_navigator_share ? faShareAlt : faCopy} />
        &nbsp; {use_navigator_share ? "Share" : "Copy results"}
      </button>
      {copied && !use_navigator_share && <div>Copied! ✅</div>}
    </>
  );
};

export default ShareButton;
